import { AnalyticsShellBrowserModule } from '@analytics/shell';
import { NgModule } from '@angular/core';
import { CityBrowserModule } from '@city/shell';
import { CoreShellBrowserModule } from '@core/shell';
import { SdvorAsmShellModule } from '@sdvor/asm/shell';

@NgModule({
  imports: [CityBrowserModule, CoreShellBrowserModule, AnalyticsShellBrowserModule, SdvorAsmShellModule],
})
export class SpartacusFeaturesBrowserModule {}
